import React from 'react';
import AdSlot from "./AdSlotComponent";

import Card from './ui/Card';

function Sobre() {
    return (
        <Card
            className="p-6 max-w-3xl mx-auto"
            data-editorial-content="true"
        >
            <h1 className="text-2xl font-bold mb-4">Sobre o Pleini Pouquer</h1>
            <p className="mb-2">
                O <strong>Pleini Pouquer</strong> é uma aplicação online gratuita de Scrum Poker,
                também conhecido como Planning Poker, ideal para equipes Ágeis estimarem atividades
                de forma colaborativa e divertida.
            </p>
            <p className="mb-2">
                Nosso objetivo é tornar as sessões de estimativa mais leves, eficientes e participativas.
                A plataforma foi desenvolvida com foco em simplicidade e funcionalidade.
            </p>
            <h2 className="text-lg font-semibold mt-4 mb-2">O que é Planning Poker?</h2>
            <p className="mb-2">
                Planning Poker é uma técnica de estimativa em que cada participante escolhe uma carta
                representando sua avaliação de esforço ou complexidade. As cartas são reveladas ao mesmo tempo,
                evitando viés e incentivando discussão quando há divergência. É amplamente usada em Scrum e
                outras metodologias ágeis para estimar histórias de usuário e tarefas.
            </p>
            <p className="mb-2">
                Aqui você pode usar sequências numéricas (linear, pares ou Fibonacci), além de opções como
                &quot;?&quot; para dúvida e &quot;☕&quot; para pausa, tornando as reuniões mais objetivas e
                alinhadas às boas práticas de agilidade.
            </p>
            <p className="mb-2">
                Esta aplicação foi criada por <strong>Diego Freire</strong> e é de uso livre para qualquer equipe.
                Se tiver sugestões, dúvidas ou quiser contribuir, entre em contato! 📧
            </p>
            <p className="text-gray-400 text-sm mt-4">Versão atual: 1.7.1</p>
            <>
                {/* Anúncio após conteúdo */}
                <AdSlot adSlot="7348901130475950" format="auto" />
            </>
        </Card>
    );
}

export default Sobre;